/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Company,
  CreateCompanyRequest,
  CreateCompanyWithOwner409Response,
  CreateInvitationRequest,
  ErrorEnvelope,
  ListInvitations501Response,
} from '../models/index';
import {
    CompanyFromJSON,
    CompanyToJSON,
    CreateCompanyRequestFromJSON,
    CreateCompanyRequestToJSON,
    CreateCompanyWithOwner409ResponseFromJSON,
    CreateCompanyWithOwner409ResponseToJSON,
    CreateInvitationRequestFromJSON,
    CreateInvitationRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    ListInvitations501ResponseFromJSON,
    ListInvitations501ResponseToJSON,
} from '../models/index';

export interface CreateCompanyWithOwnerRequest {
    createCompanyRequest: CreateCompanyRequest;
}

export interface CreateInvitationOperationRequest {
    createInvitationRequest: CreateInvitationRequest;
}

export interface ListInvitationsRequest {
    status?: ListInvitationsStatusEnum;
    page?: number;
    limit?: number;
}

/**
 * OnboardingApi - interface
 * 
 * @export
 * @interface OnboardingApiInterface
 */
export interface OnboardingApiInterface {
    /**
     * This endpoint creates a new company and sets the Firebase-authenticated caller as the company\'s first admin/owner. Send the Firebase ID token in the standard bearer authorization header. 
     * @summary Create a new company and its initial owner
     * @param {CreateCompanyRequest} createCompanyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    createCompanyWithOwnerRaw(requestParameters: CreateCompanyWithOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Company>>;

    /**
     * This endpoint creates a new company and sets the Firebase-authenticated caller as the company\'s first admin/owner. Send the Firebase ID token in the standard bearer authorization header. 
     * Create a new company and its initial owner
     */
    createCompanyWithOwner(requestParameters: CreateCompanyWithOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Company>;

    /**
     * Current runtime behavior: after authentication, this mounted endpoint returns `501` with a stub payload because the invitation flow is not implemented yet. 
     * @summary Unavailable stub for creating a user invitation
     * @param {CreateInvitationRequest} createInvitationRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    createInvitationRaw(requestParameters: CreateInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Current runtime behavior: after authentication, this mounted endpoint returns `501` with a stub payload because the invitation flow is not implemented yet. 
     * Unavailable stub for creating a user invitation
     * @deprecated
     */
    createInvitation(requestParameters: CreateInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * After authentication, this mounted endpoint currently returns `501` with a stub payload because invitation listing is not implemented yet. It does not currently return invitation data. 
     * @summary Unavailable stub for listing company invitations
     * @param {'pending' | 'accepted' | 'expired' | 'all'} [status] Filter invitations by status
     * @param {number} [page] Page number for pagination
     * @param {number} [limit] Number of items per page
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OnboardingApiInterface
     */
    listInvitationsRaw(requestParameters: ListInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * After authentication, this mounted endpoint currently returns `501` with a stub payload because invitation listing is not implemented yet. It does not currently return invitation data. 
     * Unavailable stub for listing company invitations
     * @deprecated
     */
    listInvitations(requestParameters: ListInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class OnboardingApi extends runtime.BaseAPI implements OnboardingApiInterface {

    /**
     * This endpoint creates a new company and sets the Firebase-authenticated caller as the company\'s first admin/owner. Send the Firebase ID token in the standard bearer authorization header. 
     * Create a new company and its initial owner
     */
    async createCompanyWithOwnerRaw(requestParameters: CreateCompanyWithOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Company>> {
        if (requestParameters['createCompanyRequest'] == null) {
            throw new runtime.RequiredError(
                'createCompanyRequest',
                'Required parameter "createCompanyRequest" was null or undefined when calling createCompanyWithOwner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("firebaseBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/onboarding/companies`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCompanyRequestToJSON(requestParameters['createCompanyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyFromJSON(jsonValue));
    }

    /**
     * This endpoint creates a new company and sets the Firebase-authenticated caller as the company\'s first admin/owner. Send the Firebase ID token in the standard bearer authorization header. 
     * Create a new company and its initial owner
     */
    async createCompanyWithOwner(requestParameters: CreateCompanyWithOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Company> {
        const response = await this.createCompanyWithOwnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Current runtime behavior: after authentication, this mounted endpoint returns `501` with a stub payload because the invitation flow is not implemented yet. 
     * Unavailable stub for creating a user invitation
     * @deprecated
     */
    async createInvitationRaw(requestParameters: CreateInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createInvitationRequest'] == null) {
            throw new runtime.RequiredError(
                'createInvitationRequest',
                'Required parameter "createInvitationRequest" was null or undefined when calling createInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/onboarding/invitations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInvitationRequestToJSON(requestParameters['createInvitationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Current runtime behavior: after authentication, this mounted endpoint returns `501` with a stub payload because the invitation flow is not implemented yet. 
     * Unavailable stub for creating a user invitation
     * @deprecated
     */
    async createInvitation(requestParameters: CreateInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createInvitationRaw(requestParameters, initOverrides);
    }

    /**
     * After authentication, this mounted endpoint currently returns `501` with a stub payload because invitation listing is not implemented yet. It does not currently return invitation data. 
     * Unavailable stub for listing company invitations
     * @deprecated
     */
    async listInvitationsRaw(requestParameters: ListInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/onboarding/invitations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * After authentication, this mounted endpoint currently returns `501` with a stub payload because invitation listing is not implemented yet. It does not currently return invitation data. 
     * Unavailable stub for listing company invitations
     * @deprecated
     */
    async listInvitations(requestParameters: ListInvitationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.listInvitationsRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const ListInvitationsStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Expired: 'expired',
    All: 'all'
} as const;
export type ListInvitationsStatusEnum = typeof ListInvitationsStatusEnum[keyof typeof ListInvitationsStatusEnum];
